exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#lists-customer-detail .vue-treeselect__control{font-size:.875rem!important;height:31px}#lists-customer-detail .vue-treeselect__control .vue-treeselect__placeholder{line-height:29px}#lists-customer-detail .button-row{margin-top:1rem;margin-bottom:0}", ""]);

// exports
